// extracted by mini-css-extract-plugin
module.exports = {"highlight":"popover-content-description_highlight__3PUqW"};